<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col-6">
          <div class="row">
            <h3
              class="ml-md-3 ml-1 mb-md-0"
              :class="type === 'dark' ? 'text-white' : ''"
            >
              {{ title }}
            </h3>
            <base-button
              type="primary"
              size="sm"
              class="ml-1"
              @click="showFilterModal = true"
              >ขั้นสูง</base-button
            >
            <!-- <div class="row ml-md-1 ml-1">
              <select
                v-model="selectedAgent"
                @change="onSelectAgent($event)"
                class="ml-md-2"
              >
                <option value="">ทั้งหมด</option>
                <option
                  v-for="agent in masterAgent"
                  :key="agent.id"
                  :value="agent.id"
                  >{{ agent.name }}</option
                >
              </select>
              <select
                v-model="selectedMonth"
                @change="onSelectMonth($event)"
                class="ml-md-2 mr-2 mt-2 mt-md-0"
              >
                <option value="" disabled selected>เดือน</option>
                <option
                  v-for="month in masterMonth"
                  :key="month.id"
                  :value="month.id"
                  >{{ month.name }}</option
                >
              </select>
              <select
                v-model="selectedYear"
                @change="onSelectYear($event)"
                class="mt-2 mt-md-0"
              >
                <option value="" disabled selected>ปี</option>
                <option v-for="year in masterYear" :key="year" :value="year">{{
                  year
                }}</option>
              </select>
              <base-button
                type="primary"
                size="sm"
                class="ml-md-2 mt-md-0 mt-2"
                :class="lvl != 999 ? 'none' : ''"
                @click="onExport"
                >Export</base-button
              >
            </div> -->
          </div>
        </div>
        <div class="col-6 text-right">
          <span v-show="isSelecting">
            <base-button type="warning" size="sm" @click="selectAll()"
              >เลือกทั้งหมด</base-button
            ><base-button
              type="primary"
              size="sm"
              class="mt-2 mt-xs-0 mt-sm-0"
              @click="sendAllPostcard"
              >เอกสาร</base-button
            >
            <base-button
              type="default"
              size="sm"
              class="mt-2 mt-sm-0 mt-md-0 mt-lg-0"
              @click="showAllModal = true"
              >SMS</base-button
            >
            <base-button
              type="danger"
              size="sm"
              class="mt-2 mt-md-2 mt-lg-0"
              @click="isSelecting = false"
              >ยกเลิก</base-button
            >
          </span>
          <span class="select-container" v-show="!isSelecting">
            <base-button type="warning" size="sm" @click="isSelecting = true" :class="(lvl != 999 && lvl != 0) ? 'none' : ''"
              >เลือกหลายแถว</base-button
            ></span
          >
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="wsus"
      >
        <template slot="columns">
          <th v-show="isSelecting">#</th>
          <th>ชื่อสกุล</th>
          <th>วันหมดอายุ</th>
          <th>เลขทะเบียน</th>
          <th>เบอร์โทร</th>
          <th class="company">บริษัท</th>
          <th>แจ้งเตือนล่าสุด</th>
          <th>เบี้ยประกัน</th>
          <th :class="(lvl != 999 && lvl != 0) ? 'none' : ''"></th>
        </template>

        <template slot-scope="{ row }">
          <th v-show="isSelecting">
            <input
              type="checkbox"
              @click="toggleSelect(row.id)"
              :checked="checkIfSelect(row.id)"
            />
          </th>
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body cutname">
                <span class="name mb-0 text-sm"
                  >{{ row.name_prefix }} {{ row.name }}</span
                >
              </div>
            </div>
          </th>
          <td class="tel">
            <strong>
              {{ formatDate(row.cover_end_date) }}
            </strong>
          </td>
          <td>
            {{ row.license_plate }}
            {{
              row.license_plate_province !== -1 && row.province_plate ? row.province_plate.name : ""
            }}
          </td>
          <!-- <td>
            {{ row.province !== null ? row.province.name : "ไม่มี" }}
          </td> -->
          <td>
            {{ row.tel }}
          </td>
          <td class="company">
            {{ row.company ? row.company.nickname : "" }}
          </td>
          <td>
            {{
              row.last_sms && row.last_sms !== "0000-00-00 00:00:00"
                ? formatDate(row.last_sms)
                : "ไม่มี"
            }}
          </td>
          <td>
            {{ row.insurance_premium.toLocaleString() }}
          </td>
          <td class="text-right" :class="(lvl != 999 && lvl != 0) ? 'none' : ''">
            <base-button type="primary" size="sm" @click="showPostCard(row.id)"
              >เอกสารจัดส่ง</base-button
            >
            <base-button
              type="default"
              size="sm"
              @click="
                (showModal = true),
                  (sms.phoneNumber = row.tel),
                  (sms.id = row.id)
              "
              >SMS</base-button
            >
            <!-- <a href="#" @click="notify(row.id)"
              ><i class="ni ni-check-bold text-success ni-2x correct"
            /></a> -->
            <base-button type="success" size="sm" @click="onExtend(row.id)"
              >ต่ออายุ</base-button
            >
            <base-button v-if="lvl == 999" type="danger" size="sm" @click="removeNotify(row.id)"
              >ยกเลิก</base-button
            >
          </td>
        </template>
      </base-table>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    ></div>
    <Modal :show="showModal">
      <div class="col text-center">
        <h2>
          ต้องการส่ง SMS ไปยังหมายเลข {{ sms.phoneNumber }} <br />ใช่หรือไม่?
        </h2>
        <button
          type="button"
          class="close mt--5"
          data-dismiss="modal"
          aria-label="Close"
          @click="showModal = false"
        ></button>
        <div class="row justify-content-around mt-4">
          <base-button type="info" size="md" @click="sendSMS(sms.id)"
            >ตกลง</base-button
          >
          <base-button type="warning" size="md" @click="showModal = false"
            >ยกเลิก</base-button
          >
        </div>
      </div></Modal
    >
    <Modal :show="showSuccessModal">
      <div class="col text-center">
        <h2>ดำเนินการส่ง SMS ไปยังหมายเลข {{ sms.phoneNumber }} เรียบร้อย</h2>
        <button
          type="button"
          class="close mt--5"
          data-dismiss="modal"
          aria-label="Close"
          @click="showModal = false"
        ></button>
        <div class="row justify-content-around mt-4">
          <base-button type="info" size="md" @click="showSuccessModal = false"
            >ปิด</base-button
          >
        </div>
      </div></Modal
    >
    <Modal :show="showAllModal">
      <div class="col text-center">
        <h2>
          ต้องการส่ง SMS ไปยังบุคคลที่เลือกไว้ใช่หรือไม่?
        </h2>
        <button
          type="button"
          class="close mt--5"
          data-dismiss="modal"
          aria-label="Close"
          @click="showAllModal = false"
        ></button>
        <div class="row justify-content-around mt-4">
          <base-button type="info" size="md" @click="sendAllSms"
            >ตกลง</base-button
          >
          <base-button type="warning" size="md" @click="showAllModal = false"
            >ยกเลิก</base-button
          >
        </div>
      </div></Modal
    >
    <Modal :show="showFilterModal">
      <div class="col justify-content-center text-center">
        <h2>
          ค้นหาขั้นสูง
        </h2>
        <div class="col ml-md-1 ml-1 justify-content-center text-center">
          <div class="row" :class="(lvl != 999 && lvl != 0) ? 'none' : ''">
            <h4>ตัวแทน:</h4>
            <select
              v-model="selectedAgent"
              @change="onSelectAgent($event)"
              class="ml-2"
            >
              <option value="">ทั้งหมด</option>
              <option
                v-for="agent in masterAgent"
                :key="agent.id"
                :value="agent.id"
                >{{ agent.name }}</option
              >
            </select>
          </div>
          <div class="row mt-2">
            <h4>ตั้งแต่:</h4>
            <datepicker
              :lang="th"
              :format="momentFormat"
              value-type="timestamp"
              class="date-picker ml-2"
              placeholder="คลิกเพื่อเลือกวันหมดอายุ"
              v-model="start"
            ></datepicker>
          </div>
          <div class="row mt-2">
            <h4>ถึง:</h4>
            <datepicker
              :lang="th"
              :format="momentFormat"
              value-type="timestamp"
              class="date-picker ml-2"
              placeholder="คลิกเพื่อเลือกวันหมดอายุ"
              v-model="to"
            ></datepicker>
          </div>
          <div class="row mt-2">
            <h4>จังหวัด:</h4>
            <select
              v-model="selectedProvince"
              @change="onSelectProvince($event)"
              class="ml-2"
            >
              <option value="">ทั้งหมด</option>
              <option
                v-for="province in masterProvince"
                :key="province.id"
                :value="province.id"
                >{{ province.name }}</option
              >
            </select>
          </div>
          <div class="row mt-2">
            <h4>บริษัท:</h4>
            <select
              v-model="selectedCompany"
              @change="onSelectCompany($event)"
              class="ml-2"
            >
              <option value="">ทั้งหมด</option>
              <option
                v-for="company in masterCompany"
                :key="company.id"
                :value="company.id"
                >{{ company.name }}</option
              >
            </select>
          </div>
          <base-button
            type="primary"
            size="sm"
            class="mt-2"
            :class="lvl != 999 ? 'none' : ''"
            @click="onExport"
            >Export</base-button
          >
        </div>
        <div class="row justify-content-around mt-4">
          <base-button
            type="info"
            size="md"
            @click="advanceSearch(''), (showFilterModal = false)"
            >ค้นหา</base-button
          >
          <base-button type="warning" size="md" @click="showFilterModal = false"
            >ยกเลิก</base-button
          >
        </div>
      </div></Modal
    >
  </div>
</template>
<script>
import Modal from "../../components/Modal";
import moment from "moment";
import axios from "axios";
import Datepicker from "vue2-datepicker";
import kickMixin from "../../mixins/kickMixin";
import XLSX from "xlsx";

moment.locale("th");

export default {
  name: "reminder-table",
  mixins: [kickMixin],
  components: {
    Modal,
    Datepicker,
  },
  props: {
    type: {
      type: String,
    },
    title: String,
    wsus: {
      type: Array,
      default: function() {
        return [];
      },
    },
    total: {
      type: Number,
    },
    page: {
      type: Number,
    },
  },
  data() {
    return {
      isSelecting: false,
      isSelectAll: false,
      lvl: 0,
      showModal: false,
      showFilterModal: false,
      showAllModal: false,
      showSuccessModal: false,
      showAllSuccessModal: false,
      selectedAgentIdx: "",
      selectedProvinceIdx: "",
      selectedCompanyIdx: "",
      selectedAgent: "",
      selectedProvince: "",
      selectedCompany: "",
      start: this.getStartDateInMonth(),
      to: this.getEndDateInMonth(),
      selectedRow: [],
      selectedMonth: "",
      selectedYear: "",
      masterProvince: [],
      masterAgent: [],
      masterYear: [
        moment().year() - 5 + 543,
        moment().year() - 4 + 543,
        moment().year() - 3 + 543,
        moment().year() - 2 + 543,
        moment().year() - 1 + 543,
        moment().year() + 543,
        moment().year() + 1 + 543,
        moment().year() + 2 + 543,
        moment().year() + 3 + 543,
        moment().year() + 4 + 543,
        moment().year() + 5 + 543,
      ],
      masterMonth: [],
      masterCompany: [],
      th: {
        formatLocale: {
          firstDayOfWeek: 1,
          monthsShort: [
            "ม.ค.",
            "ก.พ.",
            "มี.ค.",
            "เม.ย.",
            "พ.ค.",
            "มิ.ย.",
            "ก.ค.",
            "ส.ค.",
            "ก.ย.",
            "ต.ค.",
            "พ.ย.",
            "ธ.ค.",
          ],
          weekdaysMin: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
        },
        monthBeforeYear: true,
      },
      momentFormat: {
        stringify: (date) => {
          return date
            ? moment(date)
                .add(543, "y")
                .format("D MMM YYYY")
            : null;
        },
        parse: (value) => {
          return value
            ? moment(value, "D MMM YYYY")
                .subtract(543, "y")
                .toDate()
            : null;
        },
      },
      sms: {
        phoneNumber: "",
        id: "",
      },
    };
  },
  methods: {
    formatDate(date) {
      let monthNames = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.",
      ];

      let day = moment(date).date();
      let month = monthNames[moment(date).month()];
      let year = moment(date).year() + 543;

      // let parsedDate = Date.parse(date);
      // let newDate = new Date(parsedDate);
      // let day = newDate.getDate();
      // let month = newDate.getMonth();
      // let year = newDate.getYear();

      // let hour = newDate.getHours();
      // let min = newDate.getMinutes();
      // let sec = newDate.getSeconds();
      // return (
      //   day +
      //   " " +
      //   monthNames[month] +
      //   " " +
      //   (year + 543 + 1900) +
      //   " " +
      //   hour +
      //   ":" +
      //   min +
      //   ":" +
      //   sec
      // );
      return day + " " + month + " " + year;
    },
    notify(id) {
      axios
        .patch("/api/wsu/notify/" + id, null, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            window.location.reload();
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    removeNotify(id) {
      if (confirm("ต้องการยกเลิกการเตือนต่ออายุใช่หรือไม่?")) {
        axios
          .patch("/api/wsu/removenotify/" + id, null, {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              window.location.reload();
            }
          })
          .catch(function(error) {
            alert(error);
          });
      }
    },
    sendSMS(id) {
      let localApp = this;
      localApp.showModal = false;
      axios
        .post(
          "/api/sms",
          {
            id: id,
            tel: localApp.sms.phoneNumber,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            localApp.showSuccessModal = true;
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    showPostCard(id) {
      window.open("/api/wsu/getPostCard/" + id, "_blank");
      // axios
      //   .get("/api/wsu/getPostCard/" + id, {
      //     headers: {
      //       Authorization: "Bearer " + localStorage.token,
      //     },
      //     responseType: "blob",
      //   })
      //   .then(function(response) {
      //     const url = window.URL.createObjectURL(new Blob([response.data]));
      //     const link = document.createElement("a");
      //     link.href = url;
      //     link.setAttribute("download", name + ".pdf");
      //     document.body.appendChild(link);
      //     link.click();
      //   })
      //   .catch(function(error) {
      //     alert(error);
      //   });
    },
    getMonths: function() {
      var localApp = this;
      axios
        .get("/api/master/month", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterMonth = response.data.data;

            localApp.selectedMonth = moment().month() + 1;
            localApp.selectedYear = moment().year() + 543;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getAgents: function() {
      var localApp = this;
      axios
        .get("/api/master/agent", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterAgent = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getProvince: function() {
      var localApp = this;
      axios
        .get("/api/master/province", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterProvince = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getCompany: function() {
      var localApp = this;
      axios
        .get("/api/master/company", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterCompany = response.data.data.filter(
              (company) => company.nickname !== "UPP"
            );
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    onSelectAgent: function(event) {
      this.selectedAgentIdx = event.target.value;
    },
    onSelectProvince: function(event) {
      this.selectedProvinceIdx = event.target.value;
    },
    onSelectCompany: function(event) {
      this.selectedCompanyIdx = event.target.value;
    },
    getStartDateInMonth() {
      let today = new Date();
      let firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      return firstDayOfMonth.getTime();
    },
    getEndDateInMonth() {
      let today = new Date();
      let lastDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
      );
      return lastDayOfMonth.getTime();
    },
    // loadAlmostExpired: function() {
    //   var localApp = this;
    //   axios
    //     .get(
    //       "/api/wsu/expired?page=" +
    //         localApp.paginate.page,
    //       {
    //         headers: {
    //           Authorization: "Bearer " + localStorage.token,
    //         },
    //       }
    //     )
    //     .then(function(response) {
    //       localApp.$emit("update:wsus", response.data.data.data);
    //       localApp.$emit("update:total", response.data.data.total);
    //     })
    //     .catch(function() {
    //       localApp.kick();
    //     });
    // },
    advanceSearch: function(text) {
      var localApp = this;
      axios
        .get(
          "/api/wsu/searchAlmostExpired/advance?page=" +
            localApp.page +
            "&text=" +
            text +
            "&startDate=" +
            this.start +
            "&endDate=" +
            this.to +
            "&agent=" +
            this.selectedAgentIdx +
            "&province=" +
            this.selectedProvinceIdx +
            "&company=" +
            this.selectedCompanyIdx,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.$emit("update:wsus", response.data.data.data);
          localApp.$emit("update:total", response.data.data.total);
        })
        .catch(function() {
          localApp.kick();
        });
    },
    loadAlmostExpired: function() {
      var localApp = this;
      axios
        .get(
          "/api/wsu/expired?page=" +
            localApp.page +
            "&month=" +
            this.selectedMonth +
            "&year=" +
            this.selectedYear +
            "&agent=" +
            this.selectedAgent,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.$emit("update:wsus", response.data.data.data);
          localApp.$emit("update:total", response.data.data.total);
        })
        .catch(function() {
          localApp.kick();
        });
    },
    onExtend(id) {
      let routeData = this.$router.resolve({
        path: "/CustomerWsuExtend/" + id,
      });
      window.open(routeData.href, "_blank");
    },
    export: function() {
      var localApp = this;
      let text = localApp.$parent.keyword;

      axios
        .get(
          "/api/wsu/export?page=" +
            localApp.page +
            "&text=" +
            text +
            "&startDate=" +
            this.start +
            "&endDate=" +
            this.to +
            "&agent=" +
            this.selectedAgentIdx +
            "&province=" +
            this.selectedProvinceIdx +
            "&company=" +
            this.selectedCompanyIdx,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          let wsuForExport = response.data.data;
          let jsonData = [];
          if (wsuForExport.length !== 0) {
            wsuForExport.forEach((item) => {
              let jsonObject = {};

              jsonObject["ตัวแทน"] = item.get_agent ? item.get_agent.name : "";
              jsonObject["เบอร์โทร"] = item.tel;
              jsonObject["ชื่อ-สกุล"] = item.name;
              jsonObject["บริษัท"] = item.company ? item.company.nickname : "";
              jsonObject["ทะเบียน"] = item.license_plate;
              jsonObject["วันหมดอายุ พรบ."] = localApp.formatDate(
                item.cover_end_date
              );
              jsonObject["ยี่ห้อ/รุ่น"] = item.get_brand
                ? item.get_brand.name
                : "";
              jsonObject["เลขตัวถัง"] = item.body_number;
              jsonObject["เลขกรมธรรม์"] = item.policy_number;
              jsonObject["วันหมดอายุภาษี"] = localApp.formatDate(
                item.tax_due_date
              );
              jsonObject["เลขบัตรปชช."] = item.identity_no;

              jsonObject["ที่อยู่"] =
                item.address +
                " ต." +
                (item.getsub_district ? item.getsub_district.name : "") +
                " อ." +
                (item.getdistrict ? item.getdistrict.name : "") +
                " จ." +
                (item.getprovince ? item.getprovince.name : "");
              jsonObject["เบี้ยประกัน"] = item.insurance_premium;
              jsonData.push(jsonObject);
            });
            const dataWS = XLSX.utils.json_to_sheet(jsonData);
            const wb = XLSX.utils.book_new();
            var wscols = [
              { wch: 10 },
              { wch: 10 },
              { wch: 20 },
              { wch: 8 },
              { wch: 7 },
              { wch: 15 },
              { wch: 10 },
              { wch: 20 },
              { wch: 20 },
              { wch: 15 },
              { wch: 14 },
              { wch: 30 },
              { wch: 10 },
            ];

            dataWS["!cols"] = wscols;
            XLSX.utils.book_append_sheet(wb, dataWS);
            XLSX.writeFile(wb, "export.xlsx");
          } else {
            alert("ไม่มีข้อมูลที่จะ Export");
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    toggleSelect(id) {
      if (this.selectedRow.includes(id)) {
        this.selectedRow.splice(
          this.selectedRow.findIndex((v) => v === id),
          1
        );
      } else {
        this.selectedRow.push(id);
      }
    },
    checkIfSelect(id) {
      return this.selectedRow.includes(id);
    },
    selectAll() {
      let localApp = this;
      if (!localApp.isSelectAll) {
        localApp.wsus.forEach((element) => this.selectedRow.push(element.id));
        localApp.isSelectAll = true;
      } else {
        localApp.wsus.forEach((element) => this.selectedRow.pop(element.id));
        this.selectedRow.length = 0;
        localApp.isSelectAll = false;
      }
    },
    sendAllSms() {
      if (this.selectedRow.length <= 0) {
        alert("โปรดเลือกข้อมูลอย่างน้อย 1");
        return;
      }

      let localApp = this;
      localApp.showAllModal = false;
      axios
        .post(
          "/api/manysms",
          {
            id: this.selectedRow,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            localApp.showSuccessModal = true;
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    sendAllPostcard() {
      if (this.selectedRow.length <= 0) {
        alert("โปรดเลือกข้อมูลอย่างน้อย 1");
        return;
      }

      window.open(
        "/api/wsu/getManyPostCard/" + this.selectedRow,
        "_blank"
      );
    },
    onExport() {
      this.export();
    },
    do: async function() {
      await this.getAgents();
      await this.getProvince();
      await this.getCompany();

      this.loadAlmostExpired();
    },
  },
  watch: {
    page: function() {
      if (
        this.selectedAgentIdx === "" &&
        this.selectedProvinceIdx === "" &&
        this.selectedCompanyIdx === "" &&
        this.start === "" &&
        this.to === "" &&
        this.$parent.keyword === ""
      ) {
        this.loadAlmostExpired();
      } else {
        this.advanceSearch(this.$parent.keyword);
      }
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.lvl = localStorage.level;
      this.do();
    }
  },
};
</script>
<style scoped>
.tel {
  color: red;
}
.correct {
  vertical-align: middle;
}
a {
  cursor: pointer;
}
.table td,
.btn-sm,
.text-sm {
  font-size: 1rem !important;
}
.table thead th,
.table th {
  font-size: 0.9rem !important;
}

.h3,
h3 {
  font-size: 1.2rem !important;
}

.cutname {
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
a {
  cursor: pointer;
}
/* .company {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */
</style>
